import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'
import createClassNames from 'classnames'

import { withStyles } from '@material-ui/core/styles'
import MuiButton from '@material-ui/core/Button'

import CsgFlex from 'components/atoms/Flex'

import theme from 'app/theme'

const styles = theme => ({
  link: {
    fontSize: 14,
    textTransform: 'none'
  },
  radius: {
    borderRadius: 20
  },
  listButton: {
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2)
  }
})

const ButtonStyled = withStyles(styles)(({ link, radius, btnColor, classes, listButton, ...props }) => {
  const classNames = createClassNames({
    [classes.link]: !!link,
    [classes.radius]: !!radius,
    [classes.listButton]: !!listButton
  })

  const style = btnColor ? { color: theme.palette[btnColor].main, borderColor: theme.palette[btnColor].main } : {}
  return <MuiButton data-testid="button" className={classNames} style={style} {...props} />
})

const Icon = styled.div`
  margin-right: ${theme.spacing(2)}px;
  display: flex;
`

const Button = ({ icon, children, ...props }) => (
  <ButtonStyled {...props}>
    <CsgFlex alignItems="center" data-testid="button-flex">
      {icon && <Icon data-testid="button-icon">{icon}</Icon>}
      {children}
    </CsgFlex>
  </ButtonStyled>
)

Button.propTypes = {
  ...MuiButton.propTypes,
  link: PropTypes.bool,
  radius: PropTypes.bool,
  color: PropTypes.string,
  listButton: PropTypes.bool,
  btnColor: PropTypes.string
}

export default Button
